import React from 'react';
import { Hero } from '../components/sections/Hero';
import { PainPoints } from '../components/sections/PainPoints';
import { ProductDetails } from '../components/sections/ProductDetails';
import { Pricing } from '../components/sections/Pricing';
import { FAQ, Footer } from '../components/sections/FAQ';
import { OfferBlock } from '../components/sections/OfferBlock';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-blue-200 selection:text-blue-900" data-id="element-227">
      <PurchaseNotification data-id="element-228" />
      <Hero data-id="element-229" />
      <PainPoints data-id="element-230" />
      <ProductDetails data-id="element-231" />
      <Pricing data-id="element-232" />
      <FAQ data-id="element-233" />

      {/* Closing offer — identical to the main offer, placed before the footer */}
      <section className="py-10 md:py-20 bg-sky-50/50 border-t border-slate-100" data-id="element-234">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
          <OfferBlock heading="No dejes pasar esta oportunidad" data-id="element-236" />
        </div>
      </section>

      <Footer data-id="element-237" />
    </div>;
}